import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

interface FreeTaxConfig {
  limitFreeTax?: number;
}

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  constructor(private db: AngularFireDatabase) { }

  getFreeDeliveryLimit(): Observable<number> {
    return this.db
      .object<number>('config/confFreeTax/limitFreeTax')
      .valueChanges()
      .pipe(map(v => Number(v ?? 0)));
  }
}
